export default __webpack_public_path__ + "static/media/ic-part-test.d06fccc8.svg";